module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-5-5-43a85a77934257c54996838bb8b91a06.png";